import { Dialog } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SelectSiteSearchInputComponent from "../../components/site/select-site-search-input.component";
import { formats } from "../../config/constants";
import FootTrafficModel from "../../models/foot-traffic/foot-traffic.model";
import ViewBase from "../view-base.view";

export default function FootTrafficView() {
  ViewBase.call(this);

  let isExcelUploadModalOpen = false;

  let fileInput = null;
  let searchResult = [];

  let trafficFromDate = moment().format(formats.dateFormat);
  let trafficToDate = moment().format(formats.dateFormat);

  let selectedSites = [];

  let currentResultFilter;

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  const handleChangeTrafficDate = (e) => {
    trafficFromDate = moment(e.detail.start).format(formats.dateFormat);
    trafficToDate = moment(e.detail.end).format(formats.dateFormat);
  };

  const handleChangeSites = (sites) => {
    selectedSites = sites;
  };

  const handleClearFilter = () => {
    trafficFromDate = moment().format(formats.dateFormat);
    trafficToDate = moment().format(formats.dateFormat);
    selectedSites = [];
  };

  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    fetchData();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    fetchData();
  };

  const openExcelUploadModal = () => { isExcelUploadModalOpen = true; };

  const closeExcelUploadModal = () => {
    isExcelUploadModalOpen = false;
    fileInput = null;
  };

  const downloadTemplate = () => {
    this.showLoading();
    FootTrafficModel.downloadTemplate()
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); });
  };

  const submitUploadTemplate = (e) => {
    e.preventDefault();
    uploadAndValidate();
  };

  const uploadAndValidate = () => {
    if (!fileInput) return;

    this.showLoading();
    const formData = new FormData();
    formData.append("uploadedExcel", fileInput);
    FootTrafficModel.uploadAndValidate(formData)
      .then(() => {
        this.showMessage(
          this.getText("LT00000914", "The file has been uploaded successfully"),
          this.getText("EM00000313", "Upload Completed"),
          () => { isExcelUploadModalOpen = false }
        );
      })
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); });
  };

  const handleUploadInputChange = (e) => {
    fileInput = e.target.files?.[0];
  };

  const fetchData = () => {
    this.showLoading();
    let payload = {
      trafficFrom: trafficFromDate,
      trafficTo: trafficToDate,
      channel: selectedSites.map((site) => site.siteId).join("^"),
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
    }
    FootTrafficModel.searchFootTraffic(payload)
      .then((result) => {
        searchResult = result.data;
        pagination.totalItems = result.total;
        pagination.pageIndex = result.pageIndex;
        pagination.pageSize = result.pageSize;
        currentResultFilter = structuredClone(payload)
      })
      .catch((error) => { this.handleError(error); })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleClickSearch = () => {
    pagination.pageIndex = 1;
    fetchData();
  };

  const DOWNLOAD_TYPE = {
    SUMMARY: 'Summary',
    RAW_DATA: 'RawData'
  }

  let isDownloadingFiles = {
    [DOWNLOAD_TYPE.SUMMARY]: false,
    [DOWNLOAD_TYPE.RAW_DATA]: false
  };

  const downloadExcel = (type) => {
    let { pageIndex, pageSize, ...payload } = currentResultFilter
    isDownloadingFiles[type] = true;
    switch (type) {
      case DOWNLOAD_TYPE.RAW_DATA:
        FootTrafficModel.downloadExcel(payload, `FootTraffic_RawData_${moment(payload.trafficFrom).format(formats.apiDateFormat)}-${moment(payload.trafficTo).format(formats.apiDateFormat)}`)
          .catch(error => {
            this.handleError(error)
          })
          .finally(() => { isDownloadingFiles[type] = false; })
        break;
      case DOWNLOAD_TYPE.SUMMARY:
        FootTrafficModel.downloadSummaryExcel(payload, `FootTraffic_Summary_${moment(payload.trafficFrom).format(formats.apiDateFormat)}-${moment(payload.trafficTo).format(formats.apiDateFormat)}`)
          .catch(error => {
            this.handleError(error)
          })
          .finally(() => { isDownloadingFiles[type] = false; })
      default:
        break;
    }
  }

  return {
    view: () => {
      return [
        m(".card.mb-3",
          m(".card-body",
            m(".row.g-2",
              m(".col-md-6.col-lg-3",
                m("label.form-label",
                  this.getText("LT00000798", "Traffic Date")
                ),
                m(DatePickerComponent, {
                  class: "form-control",
                  isRange: true,
                  format: formats.dateFormat,
                  dateStart: trafficFromDate,
                  dateEnd: trafficToDate,
                  onselect: handleChangeTrafficDate,
                })
              ),

              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00000071", "Site")),
                m("div",
                  m(SelectSiteSearchInputComponent, {
                    multiple: true,
                    selectedItems: selectedSites,
                    onSelect: handleChangeSites,
                  })
                )
              )
            ),

            m(".row.g-2.justify-content-end.mt-2.mt-md-3",
              m(".col-12.gap-2.d-flex.justify-content-end.flex-wrap",
                m("button.btn.btn-primary",
                  { onclick: handleClickSearch },
                  this.getText("LT00000001", "Search")
                ),

                m("button.btn.btn-white",
                  { onclick: handleClearFilter },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        m(".card",
          m(".d-flex.justify-content-end.gap-2.mt-2.me-2",
            m('.input-group.w-auto',
              m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                {
                  disabled: searchResult?.length <= 0,
                },
                Object.values(isDownloadingFiles).includes(true)
                  ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                  : m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText("LT00000492", "Download")
              ),
              m('ul.dropdown-menu',
                m('li',
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    class: isDownloadingFiles[DOWNLOAD_TYPE.RAW_DATA] ? 'disabled' : '',
                    onclick: (e) => {
                      e.preventDefault();
                      downloadExcel(DOWNLOAD_TYPE.RAW_DATA)
                    },
                  },
                    isDownloadingFiles[DOWNLOAD_TYPE.RAW_DATA] &&
                    m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                    this.getText('LT00008050', 'Raw Data')
                  )
                ),
                m('li',
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    class: isDownloadingFiles[DOWNLOAD_TYPE.SUMMARY] ? 'disabled' : '',
                    onclick: (e) => {
                      e.preventDefault();
                      downloadExcel(DOWNLOAD_TYPE.SUMMARY)
                    },
                  },
                    isDownloadingFiles[DOWNLOAD_TYPE.SUMMARY] &&
                    m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                    this.getText("LT00001095", "Summary")
                  )
                ),
              )
            ),
            m("button.btn.btn-primary",
              {
                onclick: openExcelUploadModal,
              },
              m("i.bi.bi-file-earmark-arrow-up-fill"),
              this.getText("LT00000197", "Excel Upload")
            )
          ),

          m(".mt-2",
            m(".row.mx-0",
              m(".col-12.p-0",
                m(".table-responsive",
                  m("table.table",
                    m("thead.thead-bggrey",
                      m("tr.align-middle",
                        m("th[scope=col]",
                          { style: "min-width: 160px; width: 200px;" },
                          this.getText("LT00000350", "Channel Group")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000800", "Channel Name")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000801", "Actual Date")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000802", "Hour Count")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000803", "Traffic Count")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000804", "Average Count")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000805", "Max Count")
                        ),
                        m("th[scope=col]",
                          this.getText("LT00000274", "Updated By")
                        )
                      )
                    ),
                    m("tbody",
                      searchResult?.length === 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "100%" },
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      searchResult?.length > 0 &&
                      searchResult.map((item) => {
                        return m("tr",
                          m("td", item.channelGroup),
                          m("td", item.channelName),
                          m("td", item.actualDate),
                          m("td", item.hourCount),
                          m("td", item.trafficCount),
                          m("td", item.averageCount),
                          m("td", item.maxCount),
                          m("td", item.userName)
                        );
                      })
                    )
                  )
                ),
                searchResult?.length > 0 &&
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    data: searchResult,
                    onPageChanged: handlePageChanged,
                    onPageSizeChanged: handlePageSizeChanged,
                  })
                )
              )
            )
          )
        ),

        isExcelUploadModalOpen &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isExcelUploadModalOpen,
          onClose: closeExcelUploadModal,
          title: this.getText("LT00000797", "Upload Foot Traffic"),
          content: m(".container",
            m("ol",
              m("li.fw-bold.mb-4",
                m(".mb-2", this.getText("LT00000218", "Download Template")),
                m("button.btn.btn-primary",
                  {
                    onclick: downloadTemplate,
                  },
                  m("i.bi.bi-file-earmark-arrow-down"),
                  this.getText("LT00000220", "Excel Template")
                )
              ),
              m("li.fw-bold.mb-4.list-unstyled",
                m("hr")
              ),
              m("li.fw-bold.mb-4",
                { value: 2 },
                m(".mb-2", this.getText("LT00000197", "Excel Upload")),
                m("form#upload-template-form.row.g-4.fw-normal.needs-validation[novalidate]",
                  { onsubmit: submitUploadTemplate },
                  m(".col-12.position-relative",
                    m("input#file-upload.form-control[type=file][required]", {
                      onchange: handleUploadInputChange,
                    }),
                    m(".invalid-tooltip",
                      this.getText("EM00000316", "Please select a file")
                    )
                  ),
                  m(".col-12",
                    m(".d-flex.justify-content-end.mb-3.gap-2",
                      m("button.btn.btn-primary[type=submit]",
                        { disabled: !fileInput },
                        this.getText("LT00000290", "Upload")
                      ),
                      m("button.btn.btn-white[type=button]",
                        { onclick: closeExcelUploadModal },
                        this.getText("LT00000021", "Close")
                      )
                    )
                  )
                )
              )
            ),
            this.getBaseViews()
          ),
        }),

        this.getBaseViews(),
      ];
    },
  };
}
